import MapShowComponent from './show';
import '../../../sass/components/map-show/map-show.desktop.scss';

export default class MapShowDesktopComponent extends MapShowComponent {

}
